import { render, staticRenderFns } from "./icon4.vue?vue&type=template&id=e5f5073a&scoped=true&"
import script from "./icon4.vue?vue&type=script&lang=js&"
export * from "./icon4.vue?vue&type=script&lang=js&"
import style0 from "./icon4.vue?vue&type=style&index=0&id=e5f5073a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f5073a",
  null
  
)

export default component.exports